import { render, staticRenderFns } from "./DetailSummary.vue?vue&type=template&id=2815781c&"
import script from "./DetailSummary.vue?vue&type=script&lang=js&"
export * from "./DetailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports